import React, { useEffect, useState } from 'react'
import { Form, Input, Button, message, Checkbox } from 'antd'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { contexts } from '@/domains'
import { Storage } from '@/utils/Storage'
import TianaiCaptchaModal from '@/components/TianaiCaptchaModal/TianaiCaptchaModal'
import '@/styles/pages/login.less'

const { GlobalContext } = contexts

const Login = () => {
  const { login, getVerificationCode } = GlobalContext.useContainer()
  const [captchaVisible, setCaptchaVisible] = useState(false)
  const store = useLocalObservable(() => ({
    phone: ''
  }))
  useEffect(() => {
    void Storage.removeItem('token')
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('teamId')
    localStorage.removeItem('teamMap')
  }, [])
  const onFinish = async (values: any) => {
    const res = await login({ phone: values.phone, code: values.code })
    if (res) {
      message.success('登录成功')
      const hasTeam = res.userDTO?.teamList && res.userDTO.teamList.length > 0
      window.location.hash = hasTeam ? '#/home' : '#/join'
    }
  }

  const handleSendClick = () => {
    if (store.phone.length < 11) {
      message.error('请输入正确的手机号')
      return
    }
    setCaptchaVisible(true)
  }

  const handleCaptchaSuccess = async (captchaToken: string) => {
    const sent = await getVerificationCode({ phone: store.phone, captchaToken })
    if (sent) {
      message.success('验证码发送成功, 请注意查收')
    }
  }

  return (
    <div className="sparrow-wrap login">
      <div className="login-form">
        <h2>先进组织先远程，先进远程用麻雀</h2>
        <span>未注册的手机号验证后将自动创建账号</span>
        <Form onFinish={onFinish}>
          <Form.Item
            className="login-form-item"
            label=""
            name="phone"
            rules={[{ required: true, message: '请输入你的手机号' }]}
          >
            <Input
              className="login-input"
              prefix="+86"
              onChange={(e) => {
                store.phone = e.target.value
              }}
              placeholder="请输入手机号"
            />
          </Form.Item>

          <Form.Item
            className="login-form-item"
            label=""
            name="code"
            rules={[{ required: true, message: '请输入短信验证码' }]}
          >
            <Input
              className="login-input"
              suffix={
                <Button type="text" onClick={handleSendClick}>
                  发送
                </Button>
              }
              placeholder="验证码"
            />
          </Form.Item>
          <Form.Item className="login-form-item" label="" name="checkbox">
            <Checkbox className="login-checkbox" checked={true}>
              我已阅读并同意网站法律声明、隐私权策略、用户协议
            </Checkbox>
          </Form.Item>
          <Form.Item>
            <Button
              className="login-form-button"
              type="primary"
              htmlType="submit"
            >
              登录/注册
            </Button>
          </Form.Item>
        </Form>
      </div>
      <TianaiCaptchaModal
        visible={captchaVisible}
        onClose={() => setCaptchaVisible(false)}
        onSuccess={handleCaptchaSuccess}
      />
    </div>
  )
}

export default observer(Login)
